module.exports = __webpack_public_path__ + "img/mobile-menu-dark.cccbf6e1.svg";